<div class="auth-actions">
  <div class="auth-actions__buttons">
    <sc-button
      *ngIf="actionItem"
      type="link"
      (onClick)="actionItem.action()"
      id="{{actionItem.id}}">
      {{actionItem.label}}
    </sc-button>
    <span *ngIf="actionItem" class="auth-actions__separator">-</span>
    <sc-button
      type="link"
      (onClick)="openHelp()"
      id="open-help-form">
      Ayuda
    </sc-button>
  </div>
</div>
